module.exports = __webpack_public_path__ + "img/PD1500796485170786304.6565d9ae.png";